import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import moment from 'moment'
import * as R from 'ramda'

import config from '../config'

import { Row, Col } from 'antd'
import { Helmet } from 'react-helmet'

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'

import moneyImg from '../assets/images/icon-tag-money.png'
import rewardImg from '../assets/images/icon-tag-prize@3x.png'
import iosDownloadImg from '../assets/images/image_app_download_ios.png'
import andriodDownloadImg from '../assets/images/image_app_download_googleplay.png'
import stepMoneyImg from '../assets/images/icon_step_download.png'

import helthImg from '../assets/images/icon_health.png'
import adidasImg from '../assets/images/icon_adidas.png'
import stravaImg from '../assets/images/icon_strava.png'
import nikeImg from '../assets/images/icon_nike.png'
import googleImg from '../assets/images/icon_google.png'
import garminImg from '../assets/images/icon_garmin.png'
import wonderImg from '../assets/images/icon_wonder.png'
import miImg from '../assets/images/icon_mi.png'
import fishImg from '../assets/images/icon_fish.png'
import keepImg from '../assets/images/icon_keep.png'
import runrunImg from '../assets/images/icon_runrun.png'
import oserioImg from '../assets/images/icon_oserio.png'
import jumprImg from '../assets/images/icon_jumpr.png'
import arrowNext from '../assets/images/icon-arrow-next-20@3x.png'

const imgBaseUrl = config.firebase.getImageUrl()
const bannerBgImg = `${imgBaseUrl}/GameList%2Fimg_list_bg.png?alt=media`
const bannerBgMaskImg = `${imgBaseUrl}/GameList%2Fimg_list_bg_mask.png?alt=media`
const bannerBg768Img = `${imgBaseUrl}/GameList%2Fimg_list_bg_768.png?alt=media`
const bannerBgMask768Img = `${imgBaseUrl}/GameList%2Fimg_list_bg_mask_768.png?alt=media`
const bannerBg375Img = `${imgBaseUrl}/GameList%2Fimg_list_bg_375.png?alt=media`
const bannerBgMask375Img = `${imgBaseUrl}/GameList%2Fimg_list_bg_mask_375.png?alt=media`
const bannerBgPinkImg = `${imgBaseUrl}/GameList%2Fimg_list_bg_pink.png?alt=media`
const footerBgImg = `${imgBaseUrl}/GameList%2Fimg_list_footer_bg.png?alt=media`
const footerBgCoverImg = `${imgBaseUrl}/GameList%2Fimg_list_footer_cover.png?alt=media`
const footerBgPhoneImg = `${imgBaseUrl}/GameList%2Fimg_list_footer_phone.png?alt=media`
const flowImg = `${imgBaseUrl}/GameList%2Fimg_list_flow.png?alt=media`

SwiperCore.use([Navigation])

export default function GameListContent(props) {
    let history = useHistory()
    const { hots, challenge } = props

    const [stepCurrent, setStepCurrent] = useState(1)
    const [devicePage, setDevicePage] = useState(0)
    const [deviceType, setDeviceType] = useState(0)     // 0: full, 1: mobile
    const [bgImg, setBgImg] = useState({
        background: bannerBgImg,
        mask: bannerBgMaskImg,
    })

    useEffect(() => {
        const handleDeviceChange = () => {
            setDeviceType(window.innerWidth >= 1440 ? 0 : 1)
            setBgImg(
                window.innerWidth >= 1440 ? {
                    background: bannerBgImg,
                    mask: bannerBgMaskImg,
                } : window.innerWidth >= 768 ? {
                    background: bannerBg768Img,
                    mask: bannerBgMask768Img,
                } : window.innerWidth >= 0 ? {
                    background: bannerBg375Img,
                    mask: bannerBgMask375Img,
                } : {
                    ...bgImg
                }
            )
        }

        window.addEventListener("resize", handleDeviceChange)
        handleDeviceChange()

        return () => window.removeEventListener("resize", handleDeviceChange)

    }, [deviceType])

    useEffect(() => {
        setDevicePage(deviceType === 0 ? 0 : 1)
    }, [stepCurrent])

    const rewardType = (rewardType) => {
        switch (rewardType) {
            case 0:
                return "獎金賽"
            default:
                return "獎品賽"
        }
    }

    const rewardTypeImg = (rewardType) => {
        switch (rewardType) {
            case 0:
                return moneyImg
            default:
                return rewardImg
        }
    }

    const handleStep = (props) => {
        setStepCurrent(props)
    }

    const openGameInfo = (gid) => {
        history.push(`/game?gid=${gid}`)
        window.scrollTo(0, 0)
    }

    const handleDevice = () => {
        setDevicePage(
            devicePage <= 1 ? devicePage + 1
                : deviceType === 1 ? 1
                    : 0
        )
    }

    const deviceIcon = new Map([
        [0, []],
        [1, [
            helthImg,
            adidasImg,
            stravaImg,
            nikeImg,
            googleImg,
            garminImg,
            wonderImg,
            miImg,
        ]],
        [2, [
            fishImg,
            keepImg,
            runrunImg,
            oserioImg,
            jumprImg,
        ]]
    ])

    const StepNav = () => {
        return (
            <div>
                <Col span={6}>
                    <button
                        onClick={() => handleStep(1)}
                        className={stepCurrent === 1 ? 'list-step-content-nav-title-active' : 'list-step-content-nav-title'}
                    >
                        第一步
                        <hr className={stepCurrent === 1 ? "list-step-content-nav-line" : "web-hidden"} />
                    </button>
                </Col>
                <Col span={6}>
                    <button
                        onClick={() => handleStep(2)}
                        className={stepCurrent === 2 ? 'list-step-content-nav-title-active' : 'list-step-content-nav-title'}
                    >
                        第二步
                        <hr className={stepCurrent === 2 ? "list-step-content-nav-line" : "web-hidden"} />
                    </button>
                </Col>
                <Col span={6}>
                    <button
                        onClick={() => handleStep(3)}
                        className={stepCurrent === 3 ? 'list-step-content-nav-title-active' : 'list-step-content-nav-title'}
                    >
                        第三步
                        <hr className={stepCurrent === 3 ? "list-step-content-nav-line" : "web-hidden"} />
                    </button>
                </Col>
                <Col span={6}>
                    <button
                        onClick={() => handleStep(4)}
                        className={stepCurrent === 4 ? 'list-step-content-nav-title-active' : 'list-step-content-nav-title'}
                    >
                        第四步
                        <hr className={stepCurrent === 4 ? "list-step-content-nav-line" : "web-hidden"} />
                    </button>
                </Col>
            </div>
        )
    }

    const Step = () => {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>賽事專區 - FitGames</title>
                    <meta property='og:title' content={`賽事專區 - FitGames`} />
                </Helmet>

                {/* Step 1 */}
                <Row type="flex" className={stepCurrent === 1 ? "list-step-content" : "web-hidden"}>
                    <Col span={24} className="list-step-content-sub-title-control">
                        <p className="list-step-content-sub-title">報名繳費、影片量測</p>
                    </Col>
                    <Col span={24}>
                        <ul>
                            <li className="list-step-content-major" style={{ marginBottom: "30px" }}>下載FitGames App</li>
                            <li className="list-step-content-major">進行身體量測，並拍攝影片</li>
                            <li className="list-step-content-minor">僅參加增肌、減脂賽需要</li>
                        </ul>
                    </Col>
                </Row>

                {/* Step 2 */}
                <Row type="flex" justify="start" className={stepCurrent === 2 ? "list-step-content" : "web-hidden"}>
                    <Col span={24} className="list-step-content-sub-title-control">
                        <p className="list-step-content-sub-title">上傳紀錄、多種裝置串接</p>
                    </Col>
                    <Col span={24}>
                        <Row type="flex" justify="space-between" align="top">
                            <Col span={22} className={devicePage === 0 || deviceType === 1 ? "" : "web-hidden"}>
                                <ul>
                                    <li className="list-step-content-major">允許健康資料授權</li>
                                    <li className="list-step-content-minor">開啟所有類別</li>
                                    <li className="list-step-content-major" style={{ marginTop: "8px" }}>支持多種運動裝置、連結後即可匯入數據</li>
                                </ul>
                            </Col>

                            <Device type="full" />
                        </Row>
                    </Col>
                </Row>

                {/* Step 3 */}
                <Row type="flex" className={stepCurrent === 3 ? "list-step-content" : "web-hidden"}>
                    <Col span={24} className="list-step-content-sub-title-control">
                        <p className="list-step-content-sub-title">結束賽局、最終測量</p>
                    </Col>
                    <Col span={24}>
                        <ul>
                            <li className="list-step-content-major" style={{ marginBottom: "30px" }}>確認數據上傳無漏失</li>
                            <li className="list-step-content-major">進行身體量測，並拍攝影片</li>
                            <li className="list-step-content-minor">僅參加增肌、減脂賽需要</li>
                        </ul>
                    </Col>
                </Row>

                {/* Step 4 */}
                <Row type="flex" className={stepCurrent === 4 ? "list-step-content" : "web-hidden"}>
                    <Col span={24} className="list-step-content-sub-title-control">
                        <p className="list-step-content-sub-title">獎金折扣發放</p>
                    </Col>
                    <Col span={24}>
                        <ul>
                            <li className="list-step-content-major">我的錢包兌獎、出金</li>
                        </ul>
                    </Col>
                </Row>
            </div>
        )
    }

    const Device = (props) => {
        const { type } = props

        let cssType = `list-step-device-${type}`

        return (
            <>
                <Col span={22} className={R.and(devicePage > 0, stepCurrent === 2) ? cssType : "web-hidden"}>
                    <Row type="flex" justify="start" align="middle" gutter={[16, 16]}>
                        {deviceIcon.get(devicePage).map((image, index) => (
                            <Col span={5} key={index}>
                                <img src={image} className="list-step-device-icon" alt="device" />
                            </Col>
                        ))}
                    </Row>
                </Col>

                <Col span={1} className={stepCurrent === 2 ? cssType : "web-hidden"} style={{ top: "40px" }}>
                    <button className="list-step-device-arrow" onClick={() => handleDevice()}>
                        <img src={arrowNext} className="list-step-device-arrow-icon" alt="next" />
                    </button>
                </Col>
            </>
        )
    }

    return (
        <div>
            {/* Banner */}
            <Row type="flex" className="list-banner">
                <img src={bgImg.background} className="list-banner-img" alt="banner" />
                <img src={bgImg.mask} className="list-banner-mask" alt="banner-mask" />
                <img src={bannerBgPinkImg} className="list-banner-pink" alt="banner-pink" />
                <p className="list-title">熱門賽事不錯過</p>

                <Col type="flex" className="list-hots-block">
                    <Swiper
                        modules={[Navigation]}
                        freeMode={true}
                        navigation={true}
                        breakpoints={{
                            "320": {
                                "width": 270,
                                "spaceBetween": 15
                            },
                            "768": {
                                "width": 330,
                                "spaceBetween": 20
                            },
                            "1440": {
                                "width": 370,
                                "spaceBetween": 30
                            },
                        }}
                    >

                        {Object.values(hots).map((hot, index) => (
                            <SwiperSlide key={index}>
                                <button className="list-btn" onClick={() => openGameInfo(hot.gid)}>
                                    <div className="list-hots-frame">
                                        <img src={hot.imgUrl} className="list-hots-img" alt="gameImg" />

                                        {/* Registration time */}
                                        <Row type="flex" className="list-hots-time-frame">
                                            <p
                                                className={
                                                    moment().isAfter(hot.etm * 1000) ? "list-hots-time-stop"
                                                        : moment().isBefore(hot.ttm * 1000) ? "list-hots-time-not-yet"
                                                            : "list-hots-time-duration"
                                                }>
                                                {
                                                    moment().isAfter(hot.etm * 1000) ? "報名截止"
                                                        : moment().isBefore(hot.ttm * 1000) ? `${moment(hot.ttm * 1000).format('YYYY/MM/DD')} 開放報名`
                                                            : "現正報名中"
                                                }
                                            </p>
                                        </Row>

                                        {/* Game description */}
                                        <div className="list-hots-description">
                                            <p className="list-hots-title-long">{hot.title}</p>
                                            <p className="list-hots-sub-title">{hot.subTitle}</p>

                                            <Row type="flex" justify="space-between">
                                                <Col>
                                                    <Row type="flex" align="top">
                                                        <Col className="list-hots-reward-icon">
                                                            <img src={rewardTypeImg(hot.rewardType)} className="web-img" alt="reward" />
                                                        </Col>
                                                        <Col>
                                                            <p className={hot.rewardType === 0 ? "list-hots-reward-type-money" : "list-hots-reward-type-prize"}>
                                                                {rewardType(hot.rewardType)}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row type="flex" align="middle">
                                                        <p className="list-hots-reward-item-long">{hot.reward}</p>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </button>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                </Col>
            </Row>


            {/* Step and Flow */}
            <Row type="flex" justify="space-between" className="list-step-frame">
                <Col span={24}>
                    <p className="list-step-title">完成賽事四步驟</p>
                </Col>

                {/* Step */}
                <Col span={24}>
                    <Row type="flex" justify="center" className="list-step-content-nav-full">
                        <StepNav />
                    </Row>
                </Col>

                <Col className="list-step-content-frame-full" order={1}>
                    <Row type="flex" justify="start" className="list-step-content-nav">
                        <StepNav />
                    </Row>

                    <Step />
                </Col>

                <Col className="list-step-content-frame-mobile" order={3}>
                    <Row type="flex" justify="center">
                        <Col style={{ width: "330px" }}>
                            <Step />
                        </Col>

                        <Col style={{ width: "300px" }}>
                            <Device type="mobile" />
                        </Col>
                    </Row>
                </Col>

                {/* Flow */}
                <Col className="list-step-flow-frame" order={2}>
                    <Row className="list-step-flow">
                        <img src={flowImg} className="web-img" alt="flow" />

                        {/* Full size */}
                        <div className="list-step-flow-control-full">
                            <p className="list-step-flow-milstone" style={{ top: "0", left: "185px" }}>開賽日</p>
                            <p className="list-step-flow-milstone" style={{ top: "0", left: "525px" }}>完賽日</p>

                            {/* Step 1 */}
                            <p className={stepCurrent >= 1 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "111px", left: "62px" }}>報名繳費</p>
                            <img src={stepMoneyImg} className={stepCurrent >= 1 ? "list-step-flow-money-img" : "web-hidden"} alt="money" style={{ top: "10px", left: "70px" }} />
                            <i className={stepCurrent >= 1 ? "list-step-flow-light" : "web-hidden"} style={{ top: "81px", left: "87px" }}></i>
                            <i className={stepCurrent >= 1 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "78px", left: "84px" }}></i>

                            {/* Step 2 */}
                            <p className={stepCurrent >= 2 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "111px", left: "287px" }}>上傳紀錄</p>
                            <i className={stepCurrent >= 2 ? "list-step-flow-light" : "web-hidden"} style={{ top: "82px", left: "311px" }}></i>
                            <i className={stepCurrent >= 2 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "79px", left: "308px" }}></i>

                            {/* Step 3 */}
                            <p className={stepCurrent >= 3 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "111px", left: "450px" }}>最終量測</p>
                            <i className={stepCurrent >= 3 ? "list-step-flow-light" : "web-hidden"} style={{ top: "82px", left: "473px" }}></i>
                            <i className={stepCurrent >= 3 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "79px", left: "470px" }}></i>

                            {/* Step 4 */}
                            <p className={stepCurrent >= 4 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "111px", left: "651px" }}>獎金折扣發放</p>
                            <img src={stepMoneyImg} className={stepCurrent >= 4 ? "list-step-flow-money-img" : "web-hidden"} alt="money" style={{ top: "10px", left: "670px" }} />
                            <i className={stepCurrent >= 4 ? "list-step-flow-light" : "web-hidden"} style={{ top: "82px", left: "690px" }}></i>
                            <i className={stepCurrent >= 4 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "79px", left: "687px" }}></i>
                        </div>

                        {/* Phone */}
                        <div className="list-step-flow-control-phone">
                            <p className="list-step-flow-milstone" style={{ top: "0", left: "83.5px" }}>開賽日</p>
                            <p className="list-step-flow-milstone" style={{ top: "0", left: "248.5px" }}>完賽日</p>

                            {/* Step 1 */}
                            <p className={stepCurrent === 1 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "62px", left: "13px" }}>報名繳費</p>
                            <img src={stepMoneyImg} className={stepCurrent === 1 ? "list-step-flow-money-img" : "web-hidden"} alt="money" style={{ top: "5px", left: "30px" }} />
                            <i className={stepCurrent === 1 ? "list-step-flow-light" : "web-hidden"} style={{ top: "39px", left: "41px" }}></i>
                            <i className={stepCurrent === 1 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "37px", left: "39px" }}></i>

                            {/* Step 2 */}
                            <p className={stepCurrent === 2 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "62px", left: "122px" }}>上傳紀錄</p>
                            <i className={stepCurrent === 2 ? "list-step-flow-light" : "web-hidden"} style={{ top: "39px", left: "150px" }}></i>
                            <i className={stepCurrent === 2 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "37px", left: "148px" }}></i>

                            {/* Step 3 */}
                            <p className={stepCurrent === 3 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "62px", left: "202px" }}>最終量測</p>
                            <i className={stepCurrent === 3 ? "list-step-flow-light" : "web-hidden"} style={{ top: "39px", left: "230px" }}></i>
                            <i className={stepCurrent === 3 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "37px", left: "228px" }}></i>

                            {/* Step 4 */}
                            <p className={stepCurrent === 4 ? "list-step-flow-reached" : "list-step-flow-unreached"} style={{ top: "62px", left: "269px" }}>獎金折扣發放</p>
                            <img src={stepMoneyImg} className={stepCurrent === 4 ? "list-step-flow-money-img" : "web-hidden"} alt="money" style={{ top: "5px", left: "324px" }} />
                            <i className={stepCurrent === 4 ? "list-step-flow-light" : "web-hidden"} style={{ top: "39px", left: "335px" }}></i>
                            <i className={stepCurrent === 4 ? "list-step-flow-light-shadow" : "web-hidden"} style={{ top: "37px", left: "333px" }}></i>
                        </div>
                    </Row>
                </Col>
            </Row>

            {/* Current games */}
            <Row type="flex" className="list-current-setting-frame">
                <p className="list-current-setting-title">目前賽事</p>

                <Col type="flex" span={24}>
                    <Swiper
                        modules={[Navigation]}
                        freeMode={true}
                        navigation={true}
                        breakpoints={{
                            "1": {
                                "width": 270,
                                "spaceBetween": 15
                            },
                            "768": {
                                "width": 270,
                                "spaceBetween": 20
                            },
                            "1440": {
                                "width": 270,
                                "spaceBetween": 40
                            },
                        }}
                    >

                        {Object.values(challenge).map((hot, index) => (
                            <SwiperSlide key={index}>
                                <button className="list-btn" onClick={() => openGameInfo(hot.gid)}>
                                    <div className="list-current-frame">
                                        <img src={hot.imgUrl} className="list-current-img" alt="gameImg" />

                                        {/* Registration time */}
                                        <Row type="flex" className="list-current-time-frame">
                                            <p
                                                className={
                                                    moment().isAfter(hot.etm * 1000) ? "list-current-time-stop"
                                                        : moment().isBefore(hot.ttm * 1000) ? "list-current-time-not-yet"
                                                            : "list-current-time-duration"
                                                }>
                                                {
                                                    moment().isAfter(hot.etm * 1000) ? "報名截止"
                                                        : moment().isBefore(hot.ttm * 1000) ? `${moment(hot.ttm * 1000).format('YYYY/MM/DD')} 開放報名`
                                                            : "現正報名中"
                                                }
                                            </p>
                                        </Row>

                                        {/* Game description */}
                                        <div className="list-current-description">
                                            <p className="list-current-title">{hot.title}</p>
                                            <p className="list-current-sub-title">{hot.subTitle}</p>

                                            <Row type="flex" justify="space-between" className="list-current-reward-frame">
                                                <Col>
                                                    <Row type="flex" align="top">
                                                        <Col className="list-current-reward-icon">
                                                            <img src={rewardTypeImg(hot.rewardType)} className="web-img" alt="reward" />
                                                        </Col>
                                                        <Col>
                                                            <p className={hot.rewardType === 0 ? "list-current-reward-type-money" : "list-current-reward-type-prize"}>
                                                                {rewardType(hot.rewardType)}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <p className="list-current-reward-item-long">{hot.reward}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </button>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                </Col>

            </Row>

            {/* footer */}
            <Row type="flex" className="list-footer list-footer-control-full">
                <Col>
                    <div className="list-footer-mask">
                        <img src={footerBgImg} alt="footer" style={{ width: "100%", visibility: "hidden" }} />
                    </div>
                    <img src={footerBgImg} className="list-footer-bg" alt="footer" />
                </Col>
                <Col className="list-footer-cover">
                    <img src={footerBgCoverImg} className="web-img" alt="footer-cover" />
                </Col>

                <Col className="list-footer-download-frame">
                    <Row>
                        <p className="list-footer-download-title">下載 App，隨時記錄數據</p>
                    </Row>

                    <Row>
                        <p className="list-footer-download-sub-title">運動不白費，數據不遺漏</p>
                    </Row>

                    <Row type="flex" >
                        <Col>
                            <a href="https://lihi1.cc/oI2Mq" target="_blank" rel="noreferrer noopener" className="list-footer-download-btn">
                                <img src={iosDownloadImg} className="list-footer-download-img" alt="ios_Download" />
                            </a>
                        </Col>

                        <Col style={{ marginLeft: "20px" }}>
                            <a href="https://lihi1.cc/X6Wlk" target="_blank" rel="noreferrer noopener" className="list-footer-download-btn">
                                <img src={andriodDownloadImg} className="list-footer-download-img" alt="andriod_Download" />
                            </a>
                        </Col>

                    </Row>

                </Col>
            </Row>

            <Row type="flex" className="list-footer list-footer-control-phone">
                <img src={footerBgPhoneImg} className="list-footer-bg" alt="footer" />

                <a href="https://lihi1.cc/oI2Mq" target="_blank" rel="noreferrer noopener" className="list-footer-download-btn-cover-ios"> </a>

                <a href="https://lihi1.cc/X6Wlk" target="_blank" rel="noreferrer noopener" className="list-footer-download-btn-cover-andriod"> </a>
            </Row>


        </div>

    )
}





